<div class="container">
  <div class="my-account-section row pr-2 pl-2">
    <div class="col-sm-12 col-md-12 col-lg-3 my-account-left-section endasureLeft">
      <app-smarttire-left></app-smarttire-left>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-9 my-account-right-section endasureRight">

      @if (currentComponent === 'visitorInfo') {
        <app-smarttire-vistor-info></app-smarttire-vistor-info>
      }
      @if (currentComponent === 'fleetInfo') {
        <app-smarttire-fleet-info></app-smarttire-fleet-info>
      }
      @if (currentComponent === 'maintaince') {
        <app-smarttire-maintaince-info></app-smarttire-maintaince-info>
      }
      @if (currentComponent === 'savings') {
        <app-smarttire-savings-info></app-smarttire-savings-info>
      }
    </div>
  </div>
</div>
